<template>
  <div>
    <div class="content">
      <van-nav-bar v-if="backShow" left-text="返回" left-arrow @click-left="$router.go(-1)" />
      <van-dialog style="z-index: 3000" v-model:show="esignFlag" title="签名" show-cancel-button>
        <vue-esign ref="esign" :width="500" :height="700" />
        <div class="esign-btn" style="text-align: center">
          <van-button size="small" @click="handleEsignBack" style="background: #eee; margin-right: 20px">
            返回
          </van-button>
          <van-button size="small" @click="handleReset" type="primary">
            清空
          </van-button>
          <van-button style="margin-left: 20px" size="small" @click="handleGenerate" type="success">
            提交
          </van-button>
        </div>
      </van-dialog>

      <div class="title">
        <span>支付信息</span>
      </div>
      <ul>
        <li>
          <span>医院：</span>
          <span>{{ orderInfo.subjectName }}</span>
        </li>
        <li>
          <p>
            <span>处方号：</span>
            <span>{{ orderInfo.medicalAdviceCode }}</span>
          </p>
        </li>
        <li>
          <div>
            <p>
              <span>姓名：</span>
              <span>{{ orderInfo.patientName }}</span>
            </p>
            <p>
              <span>类型：</span>
              <span>营养医嘱</span>
            </p>
          </div>
        </li>
      </ul>
      <div>
        <div class="totalContent">
          <p class="title">处方支付金额</p>
          <p>
            <span style="color: var(--basic-green)">金额：</span>
            <span>￥{{ orderInfo.totalAmount || 0 }}</span>
            <span v-if="orderInfo.orderStatus === 1" style="color: var(--basic-red)">
              未缴费
            </span>
            <span v-if="orderInfo.orderStatus === 2" style="color: var(--basic-red)">
              支付中
            </span>
            <span v-if="orderInfo.orderStatus === 3" style="color: var(--basic-green)">
              已支付
            </span>
            <span v-if="orderInfo.orderStatus === 4">退款中</span>
            <span v-if="orderInfo.orderStatus === 5">已退款</span>
            <span v-if="orderInfo.orderStatus === 6">已作废，请重新开具</span>
          </p>
        </div>
        <div class="btnContent">
          <van-button v-if="orderInfo.orderStatus === 1" @click="payment" round size="small" type="success">
            立即支付
          </van-button>
          <van-button v-if="orderInfo.orderStatus === 3" @click="openInvoice" round size="small" type="success">
            发票开具
          </van-button>
        </div>
      </div>
    </div>
    <!-- 知情同意书 -->
    <van-dialog id="informedConsentForm" v-model:show="dialogShow" :lazy-render="false" title="规范营养治疗知情同意书">
      <div class="informedConsentFormCantainer">
        <div class="informedConsentFormContent" style="padding: 20px 10px 70px 10px; height: 500px; overflow: auto">
          <p>尊敬的患者、患者家属或患者的法定监护人、授权委托人：</p>
          <p style="text-indent: 24px">
            感谢您对本院医疗服务团队的信任和支持。
          </p>
          <p style="text-indent: 24px">
            营养治疗是疾病的治疗基础，在疾病的发生、发展、转归的全过程发挥着积极的作用。合理的营养治疗不仅可以降低病人的术后并发症发生率，改善器官功能，增强手术和麻醉的耐受力，还可提高临床治疗效果，改善预后，减少患者的住院时间。因此，营养治疗逐渐成为临床治疗必不可少的一部分。
          </p>
          <p style="text-indent: 24px">
            在患者的实际临床诊治过程中，医生、营养医师会根据患者的病情特征，开展合理规范的营养治疗，现将营养治疗的相关事项告知如下：
          </p>
          <p style="text-indent: 24px">
            1、按规定，现有的食字号肠内营养制剂和特殊治疗膳食均不属于医疗服务定价项目，不属于医疗保险、工伤保险及其他公费报销范围，为自主自费项目。因患者病情情况变化，每日花费会因营养制剂配方、用量及干预目的不同而价格不等。
          </p>
          <p style="text-indent: 24px">
            2、患者的营养治疗方案由医生、营养医师根据患者病情变化、营养需求及患者对肠内营养的代谢耐受情况而个性化制定。在治疗过程，会受到患者病情、临床用药及个体化消化系统差异的影响，可能会出现营养治疗效果偏倚或胃肠道不适症状等。临床医生、营养医师会根据实际情况积极处理，请患者与家属理解配合。
          </p>
          <p style="text-indent: 24px">
            3、如遇特殊途径的喂养输注技术的使用，如造口喂养等，会进一步与您或家属进行沟通确认。
          </p>
          <p style="text-indent: 24px">
            4、如患者出院后，有意继续接受营养指导服务的，可联系医院临床营养科，为自己和家人定制居家营养膳食、慢病营养指导服务，定期到院随诊及营养咨询。
          </p>
          <p style="text-indent: 24px">5、不提供医疗发票。</p>
          <p @click="esignFlag = true" v-if="esignImg" class="esign-img">
            <span>签名：</span>
            <img :src="esignImg" alt="" />
          </p>
          <div class="button-content">
            <p style="padding: 10px; text-align: right">
              <!-- <span style="color: #1989fa">点击确定进行签名</span> -->
            </p>
            <van-button @click="closeEvent" plain>关闭</van-button>
            <van-button @click="confirm" style="color: #00c180" plain>
              <span>确定</span>
              <span v-if="!esignImg">（点击签名）</span>
            </van-button>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  wechatRequestPrescription,
  esignSave,
} from '@/api/prescription/prescription'
import { onMounted, reactive, toRefs, ref } from 'vue'
import moment from 'moment'
import { useRoute, useRouter } from 'vue-router'
import {
  htmlToBase64,
} from '@/utils/common'
import { Toast } from 'vant'
import { useWechat } from '@/utils/wechat'

export default {
  setup() {
    const esign = ref(null)
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      backShow: false,
      dialogShow: false,
      orderInfo: '',
      o: route.query.o,
      c: route.query.c,
      z: route.query.z,
      esignFlag: false,
      esignImg: '',
      paymentAddress: '', // 添加这个属性定义以避免动态添加属性
      appId: '',
      wechatUrl: '',
      code: route.query.code,
    })

    // 微信相关函数将在初始化后赋值
    let getWechatOpenId
    onMounted(() => {
      state.esignImg = ''
      const beforePath = router.options.history.state.back
      let beforePathNew
      if (beforePath) {
        beforePathNew = beforePath.substring(0, beforePath.lastIndexOf('?'))
      }
      if (beforePathNew == '/order') {
        state.backShow = true
      } else {
        state.backShow = false
      }

      // 获取支付信息接口
      wechatRequestPrescription({
        o: state.o,
        c: state.c,
        url: location.href.split('#')[0],
      }).then(v => {
        const { data } = v
        state.orderInfo = data
        state.orderInfo.createTime = moment(
          state.orderInfo.createTime,
        ).format('YYYY-MM-DD HH:mm:ss')
        state.orderInfo.totalAmount = state.orderInfo.totalAmount.toFixed(2)
        state.medicalAdviceCode = data.medicalAdviceCode
        state.appId = data.wxJsticket.appId
        state.wechatUrl = data.wxJsticket.url
        state.zqtys = data.zqtys
        initializePage()
      })
    })

    // 初始化页面数据
    const initializePage = async () => {
      try {
        // 初始化微信相关函数，使用正确的参数
        const wechatFuncs = useWechat(
          state.medicalAdviceCode,
          '2', // 分类
          state.code.toString(),
          location.href.split('#')[0],
          // 'https://wx.sxmfyy.com/auth/baizhe.wechat-auth.top/pre/fx/pay?category=2&adviceCode=176774986642014',
        )

        getWechatOpenId = wechatFuncs.getWechatOpenId
        // 拿到code调用获取OpenId并且判断已支付的情况下不调用
        if (route.query.code && state.orderInfo.orderStatus == 1) {
          try {
            if (!getWechatOpenId) {
              console.error('微信OpenId函数未初始化')
              return
            }
            const openData = await getWechatOpenId()
            const responseData = JSON.parse(openData.data)
            wx.config({
              debug: false,
              appId: responseData.appId,
              timestamp: responseData.timeStamp,
              nonceStr: responseData.nonceStr,
              signature: responseData.paySign,
              jsApiList: ['chooseWXPay', 'checkJsApi'],
            })

            wx.ready(() => {
              wx.chooseWXPay({
                appId: responseData.appId,
                timestamp: responseData.timeStamp,
                nonceStr: responseData.nonceStr,
                package: responseData.package,
                signType: responseData.signType,
                paySign: responseData.paySign,
                success: function (payRes) {
                  // 获取支付信息接口
                  wechatRequestPrescription({
                    o: state.o,
                    c: state.c,
                    url: location.href.split('#')[0],
                  }).then(v => {
                    const { data } = v
                    state.orderInfo = data
                    state.orderInfo.createTime = moment(
                      state.orderInfo.createTime,
                    ).format('YYYY-MM-DD HH:mm:ss')
                    state.orderInfo.totalAmount = state.orderInfo.totalAmount.toFixed(2)
                    state.medicalAdviceCode = data.medicalAdviceCode
                    state.appId = data.wxJsticket.appId
                    state.wechatUrl = data.wxJsticket.url
                  })
                },
                cancel: function (payRes) {
                  console.log('取消支付', payRes)
                },
                fail: function (payRes) {
                  console.log('支付失败', payRes)
                },
              })
            })
          } catch (error) {
            console.log('支付过程出错:', error)
          }
        }
      } catch (error) {
        console.error('页面初始化失败:', error)
      }
    }
    // 微信授权登录
    function wechatAuto() {
      const url = state.wechatUrl
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${state.appId
        }&redirect_uri=${encodeURIComponent(
          url,
        )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    }

    const payment = () => {
      const vanPopup = document.querySelector('#informedConsentForm')
      const informedConsentFormCantainer = document.querySelector(
        '.informedConsentFormCantainer',
      )
      const informedConsentFormContent = document.querySelector(
        '.informedConsentFormContent',
      )
      const button = document.querySelector('.button-content')
      const content = document.querySelector('.content')
      const params = {
        adviceCode: state.orderInfo.medicalAdviceCode,
        zhiQingTongYiShuBase64: '',
      }
      if (state.esignImg) {
        content.style.background = '#fff'
        vanPopup.style.display = 'block'
        informedConsentFormContent.style.height = 'inherit'
        htmlToBase64(informedConsentFormCantainer, data => {
          vanPopup.style.display = 'none'
          vanPopup.style.marginTop = '0'
          params.zhiQingTongYiShuBase64 = data
          informedConsentFormContent.style.height = '500px'
          button.style.display = 'block'
          esignSave(params).then(v => {
            wechatAuto()
          })
        })
      } else {
        if (!state.zqtys) {
          vanPopup.style.display = 'none'
          content.style.zIndex = '0'
          button.style.display = 'block'
          state.dialogShow = true
          informedConsentFormContent.style.height = '500px'
        } else {
          wechatAuto()
        }
      }
    }

    // 开具发票
    const openInvoice = () => {
      localStorage.setItem(
        'changeAdviceCode',
        state.orderInfo.medicalAdviceCode,
      )
      router.push({ path: '/prescription/invoice' })
    }

    // 知情同意书点击确定
    const confirm = () => {
      const content = document.querySelector('.content')
      content.style.marginTop = '0'
      if (!state.esignImg) {
        state.esignFlag = true
      } else {
        state.dialogShow = false
      }
      content.style.zIndex = 'inherit'
      content.style.marginTop = '0'
    }

    const closeEvent = () => {
      state.dialogShow = false
      const content = document.querySelector('.content')
      content.style.marginTop = '0'
    }
    // 签名返回
    const handleEsignBack = () => {
      state.dialogShow = true
      state.esignFlag = false
    }
    // 重置画板
    const handleReset = () => {
      esign.value.reset()
    }

    // 保存图片
    const handleGenerate = () => {
      esign.value
        .generate()
        .then(res => {
          state.esignFlag = false
          state.esignImg = res
        })
        .catch(err => {
          Toast({
            position: 'top',
            message: '未检测到签名',
            zIndex: 3000,
          })
        })
    }

    return {
      payment,
      wechatAuto,
      closeEvent,
      esign,
      handleReset,
      handleEsignBack,
      handleGenerate,
      confirm,
      ...toRefs(state),
      openInvoice,
    }
  },
}
</script>
<style lang="scss" scoped>
.esign-img {
  span {
    vertical-align: middle;
  }

  img {
    width: 20%;
    @extend span;
  }
}

.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;
  height: 99vh;
  overflow: auto;
  position: relative;

  .esign-btn {
    border: 1px solid #eee;
    padding: 10px 0;

    button {
      padding: 0 15px;
    }
  }

  .totalContent {
    .title {
      opacity: 0.5;
    }

    p:last-of-type {
      background: var(--basic-price);
      padding: 16px;
      text-align: left;

      span {
        font-size: 17px;
        display: inline-block;
        width: 32%;
      }
    }
  }

  .title {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);

    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-green);
    }
  }

  ul {
    li {
      padding: 16px;
      border-bottom: 1px solid var(--basic-border-color);

      span:first-of-type {
        color: var(--basic-labe);
      }

      div {
        p {
          display: inline-block;
          width: 48%;
        }

        p:last-of-type {
          border: none;
          padding-left: 10px;
        }
      }
    }
  }
}

.btnContent {
  padding-top: 20px;

  button {
    width: 80%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}

::v-deep .van-dialog {
  top: 49%;
}

::v-deep .van-dialog__footer {
  display: none;
}

.button-content {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;

  button {
    width: 50% !important;
  }
}
</style>
